import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { SelectionAdfResult } from '@atlaskit/editor-plugin-selection-extension/types';
import type { SelectionExtensionPlugin } from '@atlaskit/editor-plugin-selection-extension/selection-extension-plugin-type';

import type { ContentType as AiIssueCreateContentType } from '@atlassian/ai-issue-create/types';

type ContentType = AiIssueCreateContentType | 'folder';

import { convertSelectionToLegacyFormat } from '@confluence/highlight-actions/entry-points/convertSelectionToLegacyFormat.ts';
import {
	BULK_ISSUE_CREATE_SIDE_PANEL_ID,
	BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from '@confluence/issue-create-side-panel/entry-points/BulkCreateSidePanelConstants.ts';
import type {
	IssueCreateSidePanelActions,
	PageMode,
} from '@confluence/issue-create-side-panel/entry-points/IssueCreateSidePanelContextProvider.ts';
import { openSingleIssueSidePanelWithSelection } from '@confluence/issue-create-side-panel/entry-points/singleCreateUtils.ts';
import type { RightSidebarContextType } from '@confluence/page-layout-context';
export interface CreateSingleJiraWorkItemHandleParams {
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	activeSelection?: Selection | null;
	selectionAdfResult?: SelectionAdfResult;
	contentId?: string;
	contentType?: ContentType;
	container: HTMLElement | null;
	lastModified?: string | null;
	isCreatedWithAi?: boolean;
	isActionItemInSelection?: boolean;
	pageMode: PageMode;
	editorAPI: PublicPluginAPI<[SelectionExtensionPlugin]> | null | undefined;
}

export const createSingleJiraWorkItemHandle = ({
	rightSidebarContext,
	actions,
	activeSelection,
	selectionAdfResult,
	contentId,
	contentType,
	container,
	lastModified,
	isActionItemInSelection,
	pageMode,
	editorAPI,
}: CreateSingleJiraWorkItemHandleParams): void => {
	if (!contentId) {
		return;
	}

	if (editorAPI !== null && editorAPI !== undefined) {
		void actions.setEditorAPI(editorAPI);
		const selectionResult = editorAPI.selectionExtension?.actions?.getSelectionAdf?.();
		void actions.setSelectedAdf(selectionResult?.selectedNodeAdf ?? undefined);
	}

	openSingleIssueSidePanelWithSelection({
		actions,
		rightSidebarContext,
		activeSelection,
		selectionAdfResult,
		contentId,
		contentType,
		container,
		lastModified,
		pageMode,
		isActionItemInSelection,
		convertSelectionToLegacyFormat,
	});
};

export interface CreateBulkJiraWorkItemsHandleParams {
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	editorAPI: PublicPluginAPI<[SelectionExtensionPlugin]> | null | undefined;
}

export const createBulkJiraWorkItemsHandle = ({
	rightSidebarContext,
	actions,
	editorAPI,
}: CreateBulkJiraWorkItemsHandleParams): void => {
	if (editorAPI !== null && editorAPI !== undefined) {
		void actions.setEditorAPI(editorAPI);
	}
	rightSidebarContext.open(BULK_ISSUE_CREATE_SIDE_PANEL_ID, BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH);
};
